module.exports = __webpack_public_path__ + "static/img/01.cdeb315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity2024111/01.jpg
// module id = 35F0
// module chunks = 0